import React from 'react';
import cx from 'classnames';

import { PropTypes } from 'helpers/react';
const { bool, string, element, func } = PropTypes;

import styles from './styles/index.scss';

const SidebarItem = ({
  selected,
  disabled,
  label,
  icon,
  iconActive,
  link,
  isCollapsed,
  onSelect,
}) => {
  const containerClasses = cx(styles['sideBar-item'], {
    [styles['sideBar-item__is-selected']]: selected,
  });
  const sidebarItemClasses = cx(styles['sideBar-item--link'], {
    [styles['sideBar-item--link--collapsed']]: isCollapsed,
  });

  const handleSelect = () => {
    onSelect([link]);
  };

  return (
    <li
      className={containerClasses}
      onClick={handleSelect}
      data-pendo-walkthrough-id={`sidebar-nav-${label
        .toLowerCase()
        .trim()
        .replace(/\W+/g, '-')}`}
    >
      <div
        className={sidebarItemClasses}
        activeClassName={styles['sideBar-item__is-selected']}
      >
        {!selected && icon && (
          <div className={styles['image-container']}>
            <img src={icon} width={18} height={18} />
          </div>
        )}
        {selected && iconActive && (
          <div className={styles['image-container']}>
            <img src={iconActive} width={18} height={18} />
          </div>
        )}
        {!isCollapsed && <span>{label}</span>}
      </div>
    </li>
  );
};

SidebarItem.propTypes = {
  selected: bool,
  disabled: bool,
  label: string.isRequired,
  icon: element,
  iconActive: element,
  link: string,
  isCollapsed: bool,
  onSelect: func,
};

export default SidebarItem;



// WEBPACK FOOTER //
// ./src/client/shared-components/SideBar/SideBarItem.js